var bidInput = '[data-bind=\'bid-input\']';
var errorMessage = '[data-high-bid-error]';
var minBidSelector = 'min-bid';

var priceFilter = /\$?[\d,]*.?\d*/;

function bindConfirmBid() {
  $(document).on('keyup', bidInput, function (e) {
    checkBidAmount(e);
  });
}

function checkBidAmount(e) {
  if (!e) { return; }

  var minBid = $(e.target).data(minBidSelector);
  if (inputBidValue() >= minBid * 10) {
    showWarning();
  } else {
    hideWarning();
  }
}

function showWarning() {
  $(errorMessage).fadeIn('slow');
}

function hideWarning() {
  $(errorMessage).fadeOut('fast');
}

function inputBidValue() {
  var inputBid = $(bidInput).val();
  if (isPrice(inputBid)) {
    return parsePrice(inputBid);
  } else {
    return 0;
  }
}

function isPrice(price) {
  return priceFilter.test(price);
}

function parsePrice(price) {
  price = price.match(priceFilter)[0];
  price = price.replace(/[$,]/g, '');
  return parseFloat(price);
}

function init(options) {
  bindConfirmBid();
}

module.exports = {
  init,
  parsePrice,
  checkBidAmount,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/auctions/bid_amount_checker.js